import React, { useState } from 'react';

import { ChevronDown } from 'lucide-react';

import ChainIcon from '@/components/ChainIcon';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '@/components/shadcn/ui/collapsible';
import { Currency } from '@/constants';
import useTokenIconByCurrency from '@/hooks/useChainIconByCurrency';
import { useBtcWallet } from '@/networks/btc-like/btc';
import { cn, truncateMidAddressInputValue } from '@/utils';

import HeaderWalletDrawerBtcWalletDetailsActions from './HeaderWalletDrawerBtcWalletDetailsActions';
import HeaderWalletDrawerBtcWalletDetailsContent from './HeaderWalletDrawerBtcWalletDetailsContent';

const HeaderWalletDrawerBtcWalletDetails: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { icon } = useTokenIconByCurrency(Currency.BTC);
  const { address } = useBtcWallet();

  return (
    <Collapsible
      open={isExpanded}
      onOpenChange={setIsExpanded}
      className={cn(
        'bg-background/60 flex w-full flex-col justify-between overflow-hidden rounded-xl',
        !isExpanded && 'gap-0'
      )}
    >
      <CollapsibleTrigger asChild>
        <div
          className={cn(
            'flex w-full cursor-pointer items-center justify-between gap-1 p-2.5 text-sm sm:px-2.5 md:px-4',
            isExpanded && 'bg-background hover:bg-background rounded-b-none'
          )}
        >
          <div className="flex w-full items-center justify-start text-left">
            <div className="bg-background relative mr-2 shrink-0 rounded-full p-1">
              <ChainIcon src={(icon as string) || ''} className="size-8" />
            </div>

            <div className="text-primary-foreground w-full overflow-hidden text-lg font-semibold">
              {truncateMidAddressInputValue((address || '')!, 16)}
            </div>

            <HeaderWalletDrawerBtcWalletDetailsActions />
          </div>
        </div>
      </CollapsibleTrigger>

      <CollapsibleContent
        className="grid grid-cols-1 gap-0 rounded-b-xl *:mx-1 *:mt-1 *:w-[calc(100%-8px)] *:bg-transparent *:px-1.5
          *:md:p-3"
      >
        <HeaderWalletDrawerBtcWalletDetailsContent />
      </CollapsibleContent>

      <div
        className={cn('flex cursor-pointer justify-center pb-2', { 'pt-2': isExpanded })}
        onClick={(e) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
      >
        <ChevronDown
          className={cn('text-muted-foreground size-4 transition-transform duration-200', { 'rotate-180': isExpanded })}
        />
      </div>
    </Collapsible>
  );
};

export default HeaderWalletDrawerBtcWalletDetails;
